"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Checkbox = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Checkbox"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = {
  "link": "AcceptTerms__link__3IC6i",
  "terms-modal-button": "AcceptTerms__terms-modal-button__JzCFf",
  "termsModalButton": "AcceptTerms__terms-modal-button__JzCFf",
  "disabled": "AcceptTerms__disabled__2VriA"
}; 
require('./AcceptTerms.css');
var AcceptTerms = /*#__PURE__*/function (_React$Component) {
  function AcceptTerms() {
    var _this;
    (0, _classCallCheck2.default)(this, AcceptTerms);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AcceptTerms, [].concat(args));
    (0, _defineProperty2.default)(_this, "handleCheckboxChange", function (_ref) {
      var value = _ref.value;
      var onChange = _this.props.onChange;
      if (value) {
        onChange({
          value: value
        });
      } else {
        onChange({
          value: undefined
        });
      }
    });
    (0, _defineProperty2.default)(_this, "onShowTermsClick", function () {
      var _this$props = _this.props,
        apiGroupInstanceId = _this$props.apiGroupInstanceId,
        isAPIGroup = _this$props.isAPIGroup,
        onShowTermsClick = _this$props.onShowTermsClick;
      if (!isAPIGroup || apiGroupInstanceId) {
        onShowTermsClick(apiGroupInstanceId);
      }
    });
    return _this;
  }
  (0, _inherits2.default)(AcceptTerms, _React$Component);
  return (0, _createClass2.default)(AcceptTerms, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        hasTerms = _this$props2.hasTerms,
        onChange = _this$props2.onChange;
      if (!hasTerms) {
        onChange({
          value: true
        });
      }
    }
  }, {
    key: "renderOath",
    value: function renderOath() {
      var _this$props3 = this.props,
        apiGroupInstanceId = _this$props3.apiGroupInstanceId,
        isAPIGroup = _this$props3.isAPIGroup,
        testId = _this$props3.testId;
      var disabled = isAPIGroup && !apiGroupInstanceId;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, "I accept the\xA0"), /*#__PURE__*/_react.default.createElement("button", {
        "data-test-id": "".concat(testId, "-link"),
        className: (0, _classnames.default)(styles.termsModalButton, (0, _defineProperty2.default)({}, styles.disabled, disabled)),
        onClick: this.onShowTermsClick,
        disabled: disabled,
        type: "button"
      }, "terms and conditions"));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        hasTerms = _this$props4.hasTerms,
        apiGroupInstanceId = _this$props4.apiGroupInstanceId,
        isAPIGroup = _this$props4.isAPIGroup,
        className = _this$props4.className,
        testId = _this$props4.testId;
      return hasTerms ? /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        className: className,
        disabled: isAPIGroup && !apiGroupInstanceId,
        name: "acceptTerms",
        tabIndex: "0",
        label: this.renderOath(),
        onChange: this.handleCheckboxChange,
        validate: {
          accepted: {
            validate: function validate(event) {
              return !!event.value;
            },
            message: ' '
          }
        },
        testId: "".concat(testId, "-checkbox")
      }) : null;
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(AcceptTerms, "defaultProps", {
  testId: 'accept-terms',
  isAPIGroup: false
});
var _default = exports.default = AcceptTerms;
//# sourceMappingURL=AcceptTerms.js.map